// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YV7T4","title":"styles_title__1dYc1"};